import config from '@/config'
import { getCookies } from '@/utils/helper'

/**
 * 通用流式请求（SSE/分片文本）
 * - 默认自动拼接 /adminapi 前缀
 * - 自动携带 Authori-zation
 * - 支持 data: {...} / data: [DONE] 行协议
 */
export async function flowRequest(options = {}) {
    const {
        url = '',
        method = 'POST',
        data = null,
        headers = {},
        withAdminapi = true,
        onMessage,
        onChunk,
        onDone
    } = options

    if (!url) throw new Error('flowRequest: url 不能为空')
    const token = getCookies('token') || ''
    const isFormData = typeof FormData !== 'undefined' && data instanceof FormData
    const baseHeaders = { 'Authori-zation': token, ...headers }
    if (!isFormData && !baseHeaders['Content-Type']) {
        baseHeaders['Content-Type'] = 'application/json'
    }

    const fullUrl = /^https?:\/\//i.test(url)
        ? url
        : `${config.apiUrl}${withAdminapi ? '/adminapi' : ''}${url.startsWith('/') ? url : `/${url}`}`

    const res = await fetch(fullUrl, {
        method,
        headers: baseHeaders,
        body: data == null ? undefined : (isFormData ? data : JSON.stringify(data))
    })

    if (!res.ok) {
        const text = await res.text().catch(() => '')
        throw new Error(text || `请求失败（HTTP ${res.status}）`)
    }

    const reader = res.body && res.body.getReader ? res.body.getReader() : null
    if (!reader) {
        const text = await res.text().catch(() => '')
        if (text && typeof onChunk === 'function') onChunk(text)
        if (typeof onDone === 'function') onDone()
        return
    }

    const decoder = new TextDecoder('utf-8')
    let buffer = ''
    let done = false

    const emitLine = (line) => {
        const raw = String(line || '').trim()
        if (!raw) return
        if (typeof onChunk === 'function') onChunk(raw)
        if (!raw.startsWith('data:')) return
        const payload = raw.slice(5).trim()
        if (!payload || payload === '[DONE]') {
            if (typeof onDone === 'function') onDone()
            return
        }
        try {
            const json = JSON.parse(payload)
            if (typeof onMessage === 'function') onMessage(json)
        } catch (e) {
            if (typeof onMessage === 'function') onMessage(payload)
        }
    }

    while (!done) {
        const chunk = await reader.read()
        done = !!chunk.done
        const value = chunk.value
        if (done) break
        buffer += decoder.decode(value, { stream: true })
        const lines = buffer.split(/\r?\n/)
        buffer = lines.pop() || ''
        lines.forEach(emitLine)
    }
    if (buffer) emitLine(buffer)
    if (typeof onDone === 'function') onDone()
}

export default flowRequest
